import JshModule from '@core/scripts/helper/jsh-module';
do {
    const {moduleScope} = JshModule('teaser/video2');
    if (moduleScope !== null) {
        const video = moduleScope.parentNode.querySelector('video');
        const playPauseButton = moduleScope.querySelector('.play-pause-button');
        const playIcon = playPauseButton.querySelector('.play-icon');
        const pauseIcon = playPauseButton.querySelector('.pause-icon');

        function updateButton() {
            if (video.paused) {
                playIcon.classList.add('active');
                pauseIcon.classList.remove('active');
                playPauseButton.setAttribute('aria-label', 'Video abspielen');
            } else {
                playIcon.classList.remove('active');
                pauseIcon.classList.add('active');
                playPauseButton.setAttribute('aria-label', 'Video pausieren');
            }
        }
        playPauseButton.addEventListener('click', function() {
            if (video.paused) {
                video.play();
                playIcon.classList.remove('active');
                pauseIcon.classList.add('active');
                playPauseButton.setAttribute('aria-label', 'Video pausieren');
            } else {
                video.pause();
                playIcon.classList.add('active');
                pauseIcon.classList.remove('active');
                playPauseButton.setAttribute('aria-label', 'Vide abspielen');
            }
        });
        video.addEventListener('play', updateButton);
        video.addEventListener('pause', updateButton);
        updateButton();
    }

} while (document.querySelector('[jsh-module="teaser/video2"]') !== null);
